import React from 'react';
import PropTypes from 'prop-types';
import styles from './scroll-down.module.css';

const ScrollDown = ({ color }) => {
  const scrollStyles = {
    default: {
      direction: styles.direction,
      line: styles.line,
    },
    white: {
      direction: [styles.direction, styles.directionWhite].join(' '),
      line: [styles.line, styles.lineWhite].join(' '),
    },
  };

  const renderScrollDown = (directionStyles, lineStyles) => {
    return (
      <div className={styles.align}>
        <div className={styles.wrapper}>
          <span className={directionStyles}>Scroll</span>
          <div className={styles.lineAlign}>
            <div className={styles.lineWrapper}>
              <div className={lineStyles}>
                <div />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {color === 'white'
        ? renderScrollDown(
            scrollStyles.white.direction,
            scrollStyles.white.line
          )
        : renderScrollDown(
            scrollStyles.default.direction,
            scrollStyles.default.line
          )}
    </React.Fragment>
  );
};

ScrollDown.propTypes = {
  color: PropTypes.string,
};

export default ScrollDown;



// WEBPACK FOOTER //
// ./src/components/scroll-down/index.js